// CONSTANTS
export const Constants = {
  SET_AB_TEST: 'SET_AB_TEST',
}
// ACTION TYPES
export type ActionTypes = {
  type: typeof Constants.SET_AB_TEST
  payload: string | null | undefined
}
// ACTION CALLS
export const Actions = {
  SET_AB_TEST: (payload: string | null | undefined): ActionTypes => ({
    type: Constants.SET_AB_TEST,
    payload,
  }),
}